import { CancelPaymentRequest, PaymentActions } from "../domain/payment";
import { cancelPaymentService } from "../infrastructure/services/cancelPaymentService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const cancelPayment = {
  async execute(key: string, cancellationComments: string): Promise<void> {
    const request: CancelPaymentRequest =
      await PaymentActions().paymentCancelRequest(key, cancellationComments);
    await cancelPaymentService.execute(
      await tokenValidation.execute(),
      request
    );
  },
};
